import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseTmaisUserEstablishmentPointsProps<T> = {
  userId: string
  filters?: {
    page?: number
    pageSize?: number
  }
  mapper?: (data: any) => T
}

export const useTmaisUserEstablishmentPoints = <T,>({
  userId,
  filters: { page, pageSize = 10 } = {},
  mapper = Mapper.default<T>(),
}: UseTmaisUserEstablishmentPointsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['tmaisUserEstablishmentPoints', userId, page, pageSize],
    queryFn: () => {
      return privateAxios.get(`/tmais/users/${userId}/points_by_establishment`, {
        params: {
          page,
          page_size: pageSize,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: !!userId,
  })

  return { data, meta, isPending, ...rest }
}
